import type { ApiClient } from "@/lib/api";

type CustomVerifierStatus = "pending" | "completed" | "failed";

export type CustomVerifierStatusResponse = {
  id: string;
  user_id: string;
  provider_id: string;
  status: CustomVerifierStatus;
  context: Record<string, unknown>;
};

export type GetCustomVerifierStatusRequest = {
  id: string;
  wait?: number;
  signal?: AbortSignal;
};

export const getCustomVerifierStatus = async (options: {
  client: ApiClient;
  params: GetCustomVerifierStatusRequest;
}): Promise<CustomVerifierStatusResponse> => {
  const { client, params } = options;
  const { id, wait = 30, signal } = params;
  const { data } = await client.get<CustomVerifierStatusResponse>(
    "/auth/status",
    {
      params: {
        id,
        wait,
      },
      signal,
    }
  );

  return data;
};
